import { getProfilesBankInformation } from 'reduxpath/ducks/ProfileBankInformation/List'

import { isAuthorized, getUserId } from 'utils/Auth'
import { createReducer } from '../../utils'

export const IS_LOADING = 'sherrinford/Project/pitch/IS_LOADING'
export const DATA = 'sherrinford/Project/pitch/DATA'

export const GET_PITCH_REQUEST = 'sherrinford/Project/pitch/GET_PITCH_REQUEST'
export const GET_PITCH_SUCCESS = 'sherrinford/Project/pitch/GET_PITCH_SUCCESS'
export const GET_PITCH_ERROR = 'sherrinford/Project/pitch/GET_PITCH_ERROR'

export const GET_PITCH_BY_ID_REQUEST = 'sherrinford/Project/pitch/GET_PITCH_BY_ID_REQUEST'
export const GET_PITCH_BY_ID_SUCCESS = 'sherrinford/Project/pitch/GET_PITCH_BY_ID_SUCCESS'
export const GET_PITCH_BY_ID_ERROR = 'sherrinford/Project/pitch/GET_PITCH_BY_ID_ERROR'

export const GET_FEEDBACK_REQUEST = 'sherrinford/Project/pitch/GET_FEEDBACK_REQUEST'
export const GET_FEEDBACK_SUCCESS = 'sherrinford/Project/pitch/GET_FEEDBACK_SUCCESS'
export const GET_FEEDBACK_ERROR = 'sherrinford/Project/pitch/GET_FEEDBACK_ERROR'

export const GET_PITCH_REFERENCE_REQUEST =
  'sherrinford/Project/pitch/GET_PITCH_REFERENCE_REQUEST'
export const GET_PITCH_REFERENCE_SUCCESS =
  'sherrinford/Project/pitch/GET_PITCH_REFERENCE_SUCCESS'
export const GET_PITCH_REFERENCE_ERROR =
  'sherrinford/Project/pitch/GET_PITCH_REFERENCE_ERROR'

export const POST_FEEDBACK_REQUEST = 'sherrinford/Project/pitch/POST_FEEDBACK_REQUEST'
export const POST_FEEDBACK_SUCCESS = 'sherrinford/Project/pitch/POST_FEEDBACK_SUCCESS'
export const POST_FEEDBACK_ERROR = 'sherrinford/Project/pitch/POST_FEEDBACK_ERROR'
export const SET_INPUT_FEEDBACK = 'sherrinford/Project/pitch/SET_INPUT_COMMENT'

export const PUT_GETPAID_REVIEW_REQUEST =
  'sherrinford/Project/pitch/PUT_GETPAID_REVIEW_REQUEST'
export const PUT_GETPAID_REVIEW_SUCCESS =
  'sherrinford/Project/pitch/PUT_GETPAID_REVIEW_SUCCESS'
export const PUT_GETPAID_REVIEW_ERROR =
  'sherrinford/Project/pitch/PUT_GETPAID_REVIEW_ERROR'

export const CHANGE_RADIO_STATUS = 'sherrinford/Project/Pitch/CHANGE_RADIO_STATUS'

export const GETPAID_STATUS = {
  IN_REVIEW: 1,
  APPROVED: 2,
  REJECTED: 3,
  CANCELED: 4,
}

export const GETPAID_STATUS_LABEL = {
  [GETPAID_STATUS.IN_REVIEW]: 'In review',
  [GETPAID_STATUS.APPROVED]: 'Approved',
  [GETPAID_STATUS.REJECTED]: 'Rejected',
}

const initialState = {
  data: {
    count: 0,
    profile: {},
    currentPage: 1,
    totalPages: 0,
    pitches: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  servicePitch: {
    id: '',
    order: '',
    pitchLine: {},
  },
  feedback: {
    rows: [
      {
        id: '',
        say: '',
        profile: {
          name: '',
        },
        user: {
          firstName: '',
          lastName: '',
        },
      },
    ],
  },
  selectedRadioPitchStatus: 'all',
  selectedPitchLoading: false,
  inputFeedback: '',
  pitchReference: {
    rows: [
      {
        url: '',
        filetype: '',
        urlRawFile: '',
      },
    ],
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
}

export default createReducer(initialState, {
  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),

  [GET_PITCH_REQUEST]: state => ({
    ...state,
    isLoading: true,
    selectedPitchLoading: true,
  }),
  [GET_PITCH_SUCCESS]: state => ({
    ...state,
    isLoading: false,
    selectedPitchLoading: false,
    // data,
  }),
  [GET_PITCH_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_PITCH_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PITCH_BY_ID_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    servicePitch: data,
  }),
  [GET_PITCH_BY_ID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [GET_FEEDBACK_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_FEEDBACK_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    feedback: data,
  }),
  [GET_FEEDBACK_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [GET_PITCH_REFERENCE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PITCH_REFERENCE_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    pitchReference: data,
  }),
  [GET_PITCH_REFERENCE_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [POST_FEEDBACK_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [POST_FEEDBACK_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [POST_FEEDBACK_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [SET_INPUT_FEEDBACK]: (state, inputFeedback) => ({
    ...state,
    inputFeedback,
  }),
  [CHANGE_RADIO_STATUS]: (state, status) => ({
    ...state,
    selectedRadioPitchStatus: status,
  }),

  [PUT_GETPAID_REVIEW_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [PUT_GETPAID_REVIEW_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [PUT_GETPAID_REVIEW_ERROR]: state => () => ({
    ...state,
    isLoading: false,
  }),
})

export const getPitch = (searchParam, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return dispatch => {
    const toDispatch = {
      type: [GET_PITCH_REQUEST, GET_PITCH_SUCCESS, GET_PITCH_ERROR],
      shuttle: {
        method: 'GET',
        path: '/pitch',
        qs: {
          search: JSON.stringify(searchParam),
        },
        authorization: `${token}`,
        universeHost: true,
      },
      nextAction: res => {
        res.pitches.map(async pitch => {
          const creatorPitch = pitch
          creatorPitch.profileBankInformation = await new Promise(resolveFn =>
            dispatch(
              getProfilesBankInformation(
                {
                  search: JSON.stringify({
                    profile: creatorPitch.profile.id,
                  }),
                },
                profileBank => resolveFn(profileBank.rows)
              )
            )
          )
          return creatorPitch
        })
        dispatch({
          type: [DATA],
          payload: res,
        })
        cb(res)
      },
    }
    return dispatch(toDispatch)
  }
}

export const getPitchById = (pitchId, cb = () => {}) => ({
  type: [GET_PITCH_BY_ID_REQUEST, GET_PITCH_BY_ID_SUCCESS, GET_PITCH_BY_ID_ERROR],
  shuttle: {
    method: 'GET',
    path: `/pitch/${pitchId}`,
    universeHost: true,
  },
  nextAction: res => {
    cb(res)
  },
})

export const getFeedback = (pitchId, cb = () => {}) => ({
  type: [GET_FEEDBACK_REQUEST, GET_FEEDBACK_SUCCESS, GET_FEEDBACK_ERROR],
  shuttle: {
    method: 'GET',
    path: `/feedback?search={"pitch":"${pitchId}"}`,
  },
  nextAction: res => {
    cb(res)
  },
})

export const getPitchReference = (pitchId, cb = () => {}) => ({
  type: [
    GET_PITCH_REFERENCE_REQUEST,
    GET_PITCH_REFERENCE_SUCCESS,
    GET_PITCH_REFERENCE_ERROR,
  ],
  shuttle: {
    method: 'GET',
    path: `/pitch_reference?search={"pitch":"${pitchId}"}`,
  },
  nextAction: res => {
    cb(res)
  },
})

export function setData(data) {
  return {
    type: [DATA],
    payload: data,
  }
}

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const setFeedback = data => ({
  type: [SET_INPUT_FEEDBACK],
  payload: data,
})

export const postFeedback = (payloads, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [POST_FEEDBACK_REQUEST, POST_FEEDBACK_SUCCESS, POST_FEEDBACK_ERROR],
    shuttle: {
      method: 'POST',
      path: '/feedback',
      authorization: `${token}`,
      payloads,
    },
    nextAction: res => {
      cb(res)
    },
  }
}

export const changeRadioStatus = payload => ({
  type: [CHANGE_RADIO_STATUS],
  payload,
})

export const putGetPaidStatus = (loanId, status, cb = () => {}) => {
  const reviewedBy = isAuthorized() ? JSON.parse(getUserId()) : ''
  const reviewedAt = new Date().toISOString()

  const payloads = { status, reviewedBy, reviewedAt }

  return {
    type: [
      PUT_GETPAID_REVIEW_REQUEST,
      PUT_GETPAID_REVIEW_SUCCESS,
      PUT_GETPAID_REVIEW_ERROR,
    ],
    shuttle: {
      method: 'PUT',
      path: `/loan/${loanId}/status`,
      payloads,
      universeHost: true,
    },
    nextAction: res => cb(),
  }
}

export const calculatePricesBeforeTax = (
  price,
  gcFeePercentage,
  whtPercentage,
  loanPercentage
) => {
  let total = price

  // / GC fee
  const gcFeePrice = (total / (1 - gcFeePercentage)) * gcFeePercentage
  total += gcFeePrice

  // / Witholding tax fee
  const whtPrice = total / (1 - whtPercentage) - total
  total += whtPrice

  const totalWithoutLoan = total

  // / GetPaid fee
  let loanPrice = 0
  if (loanPercentage) {
    loanPrice = total / (1 - loanPercentage) - total
    total += loanPrice
  }

  return {
    gcFeePrice,
    whtPrice,
    loanPrice,
    totalWithoutLoan,
    total,
  }
}

export const calculatePrices = (price, gcFee, whtFee, loanFee, processingFee, vatFee) => {
  const gcFeePercentage = parseFloat(gcFee, 10) / 100
  const whtPercentage = parseFloat(whtFee, 10) / 100
  const loanPercentage = parseFloat(loanFee, 10) / 100
  const processingFeePercentage = parseFloat(processingFee, 10) / 100
  const vatPercentage = parseFloat(vatFee, 10) / 100

  const { gcFeePrice, whtPrice, loanPrice, totalWithoutLoan, total } =
    calculatePricesBeforeTax(price, gcFeePercentage, whtPercentage, loanPercentage)

  // / store the price without the taxes
  const clientPrice = total

  let clientPriceWithTaxes = total

  // / Processing fee
  const processingFeePrice =
    clientPriceWithTaxes / (1 - processingFeePercentage) - clientPriceWithTaxes
  clientPriceWithTaxes += processingFeePrice

  // / VAT fee
  const vatPrice = clientPriceWithTaxes * vatPercentage
  clientPriceWithTaxes += vatPrice

  return {
    gcFeePrice,
    whtPrice,
    loanPrice,
    processingFeePrice,
    vatPrice,
    clientPrice,
    clientPriceWithoutLoan: totalWithoutLoan,
    clientPriceWithTaxes,
  }
}
